
import { Observable } from './druid/./druid/Observable';
import { filter } from './druid/./druid/operator/filter';

Observable.prototype.filter = filter;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    filter: typeof filter;
  }
}